var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 946 958",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.549 24.9301C294.751 -41.743 456.432 29.0631 782.617 192.585C1108.8 356.107 861.47 680.81 765.602 771.53C669.733 862.25 335.167 1040.5 141.48 913.813C-52.2065 787.126 12.6385 494.215 3.09395 331.86C-6.45057 169.506 32.3467 91.6032 163.549 24.9301Z",
    className: "Svg-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f6a33da2de7e556ff0babc8eeb58497a.svg";
export { ForwardRef as ReactComponent };